export class RegistrationDto{
  registrationNumber:string;
  emailAddress:string;
  accountName:string;
  firstName:string;
  lastName:string;
  contactId:number;
  username:string;
  password:string;
  confirmPassword:string;
  responseMessage:string;
}
